/* ==========================================================================
   OliveDrab — add to bag from a product card

   The small square button sits in the corner of the picture. One variant and
   it adds straight away; several and it opens the size row beneath, because a
   size chosen blind is a return waiting to happen. Written for touch first:
   nothing here waits on a hover that a phone never sends.

   Designed by Thriftizer.
   ========================================================================== */
(function () {
  'use strict';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function addVariant(id, qty) {
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
        return data;
      });
    }).then(function (data) {
      document.dispatchEvent(new CustomEvent('od:cart:added', { detail: { items: data, source: 'card' } }));
      document.dispatchEvent(new CustomEvent('od:cart:changed'));
      if (window.OD && window.OD.refreshCart) window.OD.refreshCart();
      return data;
    });
  }

  /* only one card may be showing its sizes at a time */
  function closeAll(except) {
    $$('.od-card.is-picking').forEach(function (c) {
      if (c !== except) {
        c.classList.remove('is-picking');
        var b = $('[data-od-card-add]', c);
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function settle(btn, card, state) {
    card.classList.remove('is-adding');
    card.classList.add(state);
    window.setTimeout(function () { card.classList.remove(state); }, state === 'is-added' ? 1800 : 2600);
    btn.disabled = false;
  }

  function bind(card) {
    if (card.dataset.odCardAddBound) return;
    card.dataset.odCardAddBound = '1';

    var btn = $('[data-od-card-add]', card);
    var quick = $('[data-od-quick]', card);
    if (!btn) return;

    var msg = $('[data-od-card-msg]', card);

    function say(text) { if (msg) msg.textContent = text || ''; }

    function commit(id) {
      if (!id) return;
      card.classList.add('is-adding');
      btn.disabled = true;
      say('');
      addVariant(id).then(function () {
        card.classList.remove('is-picking');
        btn.setAttribute('aria-expanded', 'false');
        settle(btn, card, 'is-added');
        say('Added to bag');
      }).catch(function (err) {
        settle(btn, card, 'is-failed');
        say(err.message || 'Could not add to bag');
      });
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var direct = btn.getAttribute('data-variant-id');
      if (direct) { commit(direct); return; }

      /* several sizes: show them rather than guess */
      var open = card.classList.contains('is-picking');
      closeAll(card);
      card.classList.toggle('is-picking', !open);
      btn.setAttribute('aria-expanded', String(!open));
      if (!open && quick) {
        var first = $('.od-card__size:not([disabled])', quick);
        if (first) first.focus();
      }
    });

    if (quick) {
      quick.addEventListener('click', function (e) {
        var pick = e.target.closest('[data-od-quick-add]');
        if (!pick || pick.disabled) return;
        e.preventDefault();
        e.stopPropagation();
        commit(pick.getAttribute('data-variant-id'));
      });
    }

    card.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !card.classList.contains('is-picking')) return;
      card.classList.remove('is-picking');
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    });
  }

  function boot(scope) { $$('[data-od-card]', scope || document).forEach(bind); }

  /* a tap anywhere else puts the size row away */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.od-card.is-picking')) return;
    closeAll(null);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* grids that swap in place: filters, load more, the theme editor */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('od:grid:changed', function () { boot(); });
})();
